import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { BaseWizardService } from "../base.wizard.service";
import { ApiService, InputDatastoreService, DialogService, CountryListService } from "@nrwl/common-lib";
import { ThresholdWizardStep } from "./threshold.wizard.step";
import { takeUntil } from "rxjs/operators";



@Injectable()
export class ThresholdWizardService extends BaseWizardService {
  openNew:boolean;
  state:ActivatedRoute;
  currentParam:any;


  constructor(
    dataApiService:ApiService,
    state: ActivatedRoute,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService) {
    super(dataApiService, inputDatastoreService, countryListService, dialogService);
    this.state = state;
    this.stepClass = ThresholdWizardStep;
    this.openNew = false;
  }

 //------------------------------------------------ Wizard control ----------------------------------------------------

 openWizard(
    wizardId,
    wizardConfig,
    defaultParamsById = {},
    onSuccess = () => {},
    onFail = () => {}
 ) {
   this._setOutputForEditMode(defaultParamsById);
   super.openWizard(wizardId, wizardConfig, defaultParamsById, onSuccess, onFail);
   
 }

}